// Intent: [Conversion] [Journey]
import React from "react";
import { HammerIcon, HelpCircleIcon, RulerIcon } from "lucide-react";
import { ButtonLink } from "../components/shared/ButtonLink";
import { PageHero } from "../components/shared/PageHero";
const choices = [{
  title: "Trades",
  copy: "For cabinet installers and trade customers preparing cabinetry jobs for their work.",
  detail: "Continue to the Trade registration pathway and review what to have ready.",
  href: "/register/trade/",
  icon: HammerIcon,
  tone: "bg-pfpc-navy text-pfpc-offwhite border-pfpc-navy"
}, {
  title: "Do It Yourself - Easy",
  copy: "For capable renovators planning and ordering cabinetry for their own project.",
  detail: "See the preparation checklist before continuing to DIY registration.",
  href: "/register/diy/",
  icon: RulerIcon,
  tone: "bg-pfpc-offwhite text-pfpc-navy border-pfpc-orange"
}] as const;
function RegisterPage() {
  return <main id="main-content" data-id="element-450" data-mp="unwp4r7l64ge">
      <PageHero eyebrow="Register" title="Choose the path that matches your project." copy="Trade and DIY customers use separate registration pathways so the account starts with the right context." data-id="element-451" data-mp="3p7vdmje5arc0" />
      <section className="section-shell bg-[#eceae4]" data-id="element-452" data-mp="3gftjf2uo67a6">
        <div className="container-shell" data-id="element-453" data-mp="3gf1olu8wcdky">
          <div className="grid gap-5 lg:grid-cols-2" data-id="element-454" data-mp="3kgdfe33ib4uq">
            {choices.map(({
            title,
            copy,
            detail,
            href,
            icon: Icon,
            tone
          }) => <article key={title} className={`flex min-h-[310px] flex-col rounded-2xl border p-7 md:p-9 ${tone}`} data-id="element-455" data-mp="36gcbsfvuxjbk">
                <Icon className="h-8 w-8 text-pfpc-orange" strokeWidth={1.8} data-id="element-456" data-mp="3bhiaqvg422tj" />
                <h2 className="mt-8 font-heading text-[26px] font-extrabold" data-id="element-457" data-mp="2xhqxwy1bysh4">{title}</h2>
                <p className="mt-3 max-w-[46ch] text-[16px] leading-7 opacity-75" data-id="element-458" data-mp="31j2g4ihvkbfa">{copy}</p>
                <p className="mt-3 max-w-[46ch] text-[14px] leading-6 opacity-65" data-id="element-459" data-mp="vq45qt5pcrj2">{detail}</p>
                <ButtonLink href={href} variant={title === "Trades" ? "secondaryDark" : "primary"} className="mt-auto self-start" data-id="element-460" data-mp="zqxvls2pggel">Continue</ButtonLink>
              </article>)}
          </div>
          <div className="mt-5 flex flex-col items-start justify-between gap-4 rounded-xl border border-pfpc-navy/15 bg-pfpc-offwhite p-6 sm:flex-row sm:items-center" data-id="element-461" data-mp="23o8gsmzvm3si">
            <div className="flex gap-3" data-id="element-462" data-mp="1unto32kl1mez"><HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-pfpc-orange" data-id="element-463" data-mp="1uoljaca9pi4q" /><div data-id="element-464" data-mp="2re2sv2cdfobp"><h2 className="font-heading text-lg font-extrabold text-pfpc-navy" data-id="element-465" data-mp="2rdujhkfgj159">Not sure which account applies?</h2><p className="mt-1 text-[14px] leading-6 text-pfpc-navy/65" data-id="element-466" data-mp="2ncr572d25d65">Ask the PFPC team before registering.</p></div></div>
            <ButtonLink href="/help/" variant="secondary" data-id="element-467" data-mp="2ikqx2mmu3dyh">Get Help</ButtonLink>
          </div>
        </div>
      </section>
    </main>;
}
export { RegisterPage };